import MainPage from "./components/MainPage";

function App() {
	return (
		<div className="wrapper">
			<div className="_container">
				<MainPage />
			</div>
		</div>
	);
}

export default App;
